import { InputNumber, InputNumberProps, InputNumberChangeEvent } from 'primereact/inputnumber';
import { Column } from '../container/Container';
import { TextBodyExtraExtraSmall } from '../text/Texts';
import { cn } from '../ui/cn';
import { JSX, useState } from 'react';
import { FormElementProps } from './InputController';
import { inputStyle, labelStyle } from './styles';

interface NumberInputProps extends Omit<InputNumberProps, 'value' | 'onChange' | 'onBlur'>, FormElementProps {
	label?: string;
	placeholder?: string;
	labelBgColor?: string;
	containerCls?: string;
	icon?: JSX.Element;
	iconCls?: string;
	needErrorIcon?: boolean;
}

const NumberInput = ({
	id,
	value,
	onChange,
	onBlur,
	error,

	label,
	placeholder,
	labelBgColor,
	containerCls,
	variant = 'filled',
	...numberInputProps
}: NumberInputProps) => {
	const [isFocus, setIsFocus] = useState(false);

	const hasValue = value !== null && value !== undefined && value !== '';

	return (
		<Column className={cn('w-full relative', containerCls, numberInputProps.disabled && 'opacity-50')}>
			<InputNumber
				unstyled
				{...numberInputProps}
				mode="currency"
				locale="en-PH"
				currency="PHP"
				maxFractionDigits={0}
				id={id}
				value={value}
				onChange={(e: InputNumberChangeEvent) => onChange?.(e.value)}
				onFocus={() => setIsFocus(true)}
				onBlur={() => {
					setIsFocus(false);
					onBlur?.();
				}}
				variant={undefined}
				pt={{ input: { root: { className: inputStyle({ variant, isFocus, error: !!error }) } } }}
			/>

			{/* Placeholder */}
			{(variant === 'filled' && placeholder && !hasValue) && (
				<span
					children={placeholder}
					className={cn(
						'absolute left-4 top-6',
						'transition-opacity duration-300 pointer-events-none',
						'font-poppins text-body-large text-onSurfaceVariant',
						'opacity-0', isFocus && 'opacity-100'
					)}
				/>
			)}

			{/* Label */}
			{label && (
				<label
					htmlFor={id}
					children={label}
					className={labelStyle({ variant, isFocus, hasValue, labelBgColor, error: !!error })}
				/>
			)}

			{/* Error */}
			{(error && error.message) && (
				<TextBodyExtraExtraSmall children={error.message} className="pl-4 pt-1 text-error" />
			)}
		</Column>
	);
};

export default NumberInput;
